module.exports = __webpack_public_path__ + "img/vende_tu_auto_documentos_mobile.b3cb4211.png";